import {Modal} from 'react-bootstrap'
import {PrivacyPolicyModalContent} from './PrivacyPolicyModalContent'
import {useQuery} from 'react-query'
import {PrivacyPolicy} from './core/_models'
import {useAuth} from '../../../../app/modules/auth'
import {getActivePrivacyPolicy} from './core/_requests'

export function PrivacyPolicyModal() {
  const {currentUser} = useAuth()

  function useGetPriacyPolicy() {
    const fetcher = async () => await getActivePrivacyPolicy()
    const queryResult = useQuery(['privacyPolicy'], fetcher, {
      enabled: !currentUser?.privacy_agreement,
      retry: false,
    })

    return {...queryResult, data: queryResult.data ?? ({} as PrivacyPolicy)}
  }

  const {data: privacyPolicy, isLoading} = useGetPriacyPolicy()

  return (
    <Modal
      className='px-md-5'
      id='kt_modal_adjust_time'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={!currentUser?.privacy_agreement}
      dialogClassName='mw-600px modal-dialog-centered'
    >
      {isLoading ? (
        <div className='d-flex justify-content-center my-20'>
          <span className='spinner-border'></span>
        </div>
      ) : (
        <PrivacyPolicyModalContent privacyPolicy={privacyPolicy} />
      )}
    </Modal>
  )
}
